export const DEFAULT_PAGINATION = {
    limit: 500
};